
export enum HandlingUnitTypeCd {
	LOOSE = 'Loose',
	MOTOR = 'Motor',
	UNKNOWN = 'Unknown'}

